import axios from 'axios';

// API dedicada de autenticação/permissão/menu/troca-de-cliente (ver
// docs/plano-integracao-api-seguranca.md). URL de desenvolvimento local — TROCAR pela URL
// real de homologação/produção antes do deploy.
const BASE_URL = 'https://api-seguranca.uzerpass.com.br/api/v1';

const instance = axios.create({
  baseURL: BASE_URL,
});

// Mesmo token principal salvo em localStorage['token'] no login (sagas/Auth.js) — o
// backend legado passou a confiar na assinatura desse token também (ver
// docs/plano-integracao-api-seguranca.md §1.1), então é o mesmo token pra tudo.
instance.interceptors.request.use((config) => {
  const tokenSalvo = localStorage.getItem('token');
  if (tokenSalvo) {
    let token = tokenSalvo;
    try {
      token = JSON.parse(tokenSalvo);
    } catch (err) {
      token = tokenSalvo;
    }
    config.headers['authorization'] = 'Bearer ' + token;
  }
  return config;
});

export default instance;
